import React from "react";
import { Row } from "../../bootstrap/index.jsx";
import { DATA_TYPE_RATIO } from './IndicatorForm.jsx';
import Help from "../../common/Help.jsx";
import IndicatorMilestoneFormFields from "./IndicatorMilestoneFormFields.jsx";

const QuantitativeIndicatorFormFields = ({
  indicator,
  milestonesEnabled,
  formOptions,
  updateIndicator,
  lockCommonIndicatorFields
}) => {
  const { baseline_value, data_type, value_denominator, programme_indicator_unit_id, unit_name, milestones } = indicator;

  return (
    <>
      <Row className="form-group">
        <label className="col-xs-6">
          {I18n.t("indicator_unit_id")} *
          <Help text={I18n.t("indicator_unit_help")} />
          <select
            name="programme_indicator_unit_id"
            className="form-control"
            defaultValue={programme_indicator_unit_id}
            disabled={lockCommonIndicatorFields}
          >
            <option value="">{I18n.t("select_from_list")}</option>
            {
            lockCommonIndicatorFields ?  // In case of a locked common indicator, it's possible that the unit is from another fund and it's not included in assignble units (cross fund indicators). 
              <option value={programme_indicator_unit_id}>{unit_name}</option>
            : 
            formOptions.assignable_units.map((g, i) => (
              <optgroup key={i} label={g.label}>
                {g.options.map((o, j) => (
                  <option key={j} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </label>
        <label className="col-xs-6">
          {I18n.t("data_type")} *
          <Help text={I18n.t("indicator_data_type_help")} />
          <select
            name="data_type"
            className="form-control"
            onChange={(e) => updateIndicator("data_type", e.target.value)}
            value={data_type}
            disabled={lockCommonIndicatorFields}
          >
            {formOptions.data_types.map((d, i) => (
              <option key={i} value={d.value}>
                {d.label}
              </option>
            ))}
          </select>
        </label>
      </Row>
      <hr />
      <Row className="form-group">
        <label className="col-xs-4">
          {I18n.t("baseline_value")}
          <Help text={I18n.t("indicator_baseline_value_help")} />
        </label>
        <label className="col-xs-8">
          <input
            type="text"
            name="baseline_value"
            className={`form-control ${
              data_type == DATA_TYPE_RATIO ? "fraction" : ""
            }`}
            defaultValue={baseline_value}
            placeholder={
              data_type == DATA_TYPE_RATIO ? I18n.t("numerator") : null
            }
          />
          {data_type == DATA_TYPE_RATIO && (
            <>
              <div className="fraction-dash">/</div>
              <input
                type="text"
                name="value_denominator"
                placeholder={I18n.t("denominator")}
                className="fraction form-control"
                value={value_denominator || ""}
                onChange={(e) =>
                  updateIndicator("value_denominator", e.target.value)
                }
              ></input>
            </>
          )}
        </label>
      </Row>
      <IndicatorMilestoneFormFields
        indicatorMilestones={milestones}
        milestonesEnabled={milestonesEnabled}
        dataType={data_type}
        denominator={value_denominator}
        projectMilestones={formOptions.project_milestones}
      />
    </>
  );
};

export default QuantitativeIndicatorFormFields;
